import { Component, ViewEncapsulation, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '../../../../shared/services/toast/toast.service';
import { LoaderService } from '../../../../shared/services/loader/loader.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserPreferencesService } from '../../../../shared/services/user-preferences/user-preferences.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TemplatePage } from '../../../../shared/models/template.model';
import { UserPreferencesData } from '../../../../shared/models/user-preferences.model';

@Component({
    selector: 'app-format-title-popup',
    templateUrl: './format-title-popup.component.html',
    styleUrl: './format-title-popup.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormatTitlePopupComponent implements OnInit {
  private userPreferencesService = inject(UserPreferencesService);
  dialogRef = inject<MatDialogRef<FormatTitlePopupComponent>>(MatDialogRef);
  data = inject<{
    templateId: number;
    templateData: TemplatePage[];
    titleFormat: string;
}>(MAT_DIALOG_DATA);

  userPreferencesData: UserPreferencesData;
  items: { itemCode: string; caption: string }[] = [];
  selectedItems: { itemCode: string; caption: string }[] = [];

  ngOnInit() {
    this.userPreferencesData = this.userPreferencesService.getUserPreferencesData();
    this.getFirstPageItems();
    this.retrieveSeletedItems();
  }

  getFirstPageItems(){
    this.items.push({ itemCode: 'name', caption: 'Template Name' });
    if(this.data?.templateData?.length > 0){
      this.data.templateData[0].sections?.forEach(section => {
        section.items?.forEach(item => {
          this.items.push({ itemCode: item.itemCode, caption: item.caption });
        });
      });
    }
  }

  retrieveSeletedItems() {
    this.data.titleFormat?.split("|").forEach(itemCode => {
      if(itemCode == 'name'){
        this.selectedItems.push({ itemCode: 'name', caption: 'Template Name' });
      }
      else{
        const item = this.items.filter(s => s.itemCode == itemCode);
        if(item.length > 0){
          this.selectedItems.push({ itemCode: itemCode, caption: item[0].caption });
        }
      }
    });
  }

  closeDialog(response?: { titleFormat: string }) {
    this.dialogRef.close(response);
  }

  onSubmit(): void {
    if(this.selectedItems.length == 0){
      (document.querySelector('.item-required-warning') as HTMLElement).style.display = "unset";
    }
    else{
      this.closeDialog({titleFormat: this.selectedItems.map(x => x.itemCode).join("|")});
    }
  }

  drop(event: CdkDragDrop<{ itemCode: string; caption: string }[]>) {
    if (event.previousContainer === event.container)  {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } 
    else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  removeItem(index: number) {
    this.selectedItems.splice(index, 1);
  }
}
